export function initRootFontSize() {
  let init = ()=> {
      let w = document.documentElement.offsetWidth || window.innerWidth;
      if(w >= 375) 
      document.documentElement.style.fontSize="37.5px";
  }
  window.addEventListener('resize',init);
  window.addEventListener('load',init);
  init();
}

 export function handleFontSize() {
  WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
  WeixinJSBridge.on('menu:setfont', () => {
    WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
  })
}
 if (
      typeof WeixinJSBridge === 'object'
      && typeof WeixinJSBridge.invoke === 'function'
    ) {
      handleFontSize()
    } else {
      document.addEventListener('WeixinJSBridgeReady', handleFontSize, false)
    }

    export default {
      initRootFontSize,
      handleFontSize
  }